import {AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {Store} from '@ngrx/store';

import {State} from 'src/app/store';
import * as actions from '../../../../store/auth/authentication.actions';
import * as selectors from '../../../../store/auth/authentication.selectors';
import * as selectorsApp from '../../../../store/app/app.selectors';
import {selectAppViewPort} from '../../../../store/app/app.selectors';

@Component({
  selector: 'app-forgot-password-step2',
  templateUrl: './forgot-password-step2.component.html',
  styleUrls: ['./forgot-password-step2.component.scss'],
})
export class ForgotPasswordStep2Component implements OnInit, OnDestroy, AfterViewChecked {
  reset_password_form: FormGroup;
  reset_password_spinner = false;
  error_message = '';
  user_email = '';
  platformBrandLogo = '';
  platformName = '';
  platformLandingPage = '';
  viewport = '';

  private subscriptions = [];

  constructor(
    public store: Store<State>,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.store.select(selectAppViewPort).subscribe(result => {
      this.viewport = result;
    });
    this.reset_password_form = new FormGroup({
      code: new FormControl('', [Validators.required]),
      password: new FormControl('', [
        Validators.required,
        Validators.pattern(
          '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)([A-Za-z]|[^ ]){8,}$'
        ),
      ]),
      confirm_password: new FormControl('', [
        Validators.required,
        Validators.pattern(
          '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)([A-Za-z]|[^ ]){8,}$'
        ),
      ]),
    });

    // Set custom validators for password & confirm_password fields
    this.reset_password_form.controls['password'].setValidators([
      Validators.required,
      Validators.pattern(
        '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)([A-Za-z]|[^ ]){8,}$'
      ),
      this.checkPasswordNewPassword.bind(this),
    ]);
    this.reset_password_form.controls['confirm_password'].setValidators([
      Validators.required,
      Validators.pattern(
        '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)([A-Za-z]|[^ ]){8,}$'
      ),
      this.checkPassword.bind(this),
    ]);

    this.subscriptions.push(
      // Get param email to set in field email
      this.activatedRoute.params.subscribe(params => {
        this.user_email = params['email'];
      }),
      this.store
        .select(selectors.selectResetPasswordError)
        .subscribe(errMessage => {
          this.error_message = errMessage;
        }),
      this.store
        .select(selectors.selectResetPasswordLoading)
        .subscribe(loading => {
          this.reset_password_spinner = loading;
        }),
    );
  }

  ngAfterViewChecked() {
    this.subscriptions.push(
        this.store.select(selectorsApp.selectUserGroup).subscribe(userGroup => {
          if (userGroup !== null ) {
            this.platformBrandLogo = userGroup.logo_login_url;
            this.platformName = userGroup.platform_name;
            this.platformLandingPage = userGroup.landing_page;
            this.cdr.detectChanges();
          }
        })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.store.dispatch(actions.clearErrors());
  }

  /**
   * Checks if password and confirm password are a match.
   * If passwords don't match the form becomes invalid
   * @param {FormControl} control The form control to check
   * @return {null | object} All custom validators return null if not detected custom error: object
   */
  checkPassword(control: FormControl): object | null {
    if (control.value !== this.reset_password_form.controls['password'].value) {
      return {
        no_equal: true,
      };
    }
    return null;
  }
  /**
   * Checks if password and confirm password are a match.
   * If passwords don't match the form becomes invalid
   * @param {FormControl} control The form control to check
   * @return {null | object} All custom validators return null if not detected custom error: object
   */
  checkPasswordNewPassword(control: FormControl): object | null {
    if (
      control.value !==
      this.reset_password_form.controls['confirm_password'].value
    ) {
      this.reset_password_form.get('confirm_password').setErrors({
        no_equal: true,
      });
    } else if (
      control.value ===
      this.reset_password_form.controls['confirm_password'].value
    ) {
      this.reset_password_form.get('confirm_password').setErrors(null);
    }
    return null;
  }

  /**
   * Get values for form and call confirm password service
   * If all is ok redirect to login with email
   * Else print error message
   */
  resetPassword(): void {
    if (this.reset_password_form.status !== 'INVALID') {
      this.store.dispatch(
        actions.resetPassword({
          email: this.user_email,
          code: this.reset_password_form.value.code,
          password: this.reset_password_form.value.password,
        })
      );
    }
  }
}
